<template>
  <div class="current-area">
    <h3 class="current-area__item">
      <font-awesome-icon class="current-area__icon" :icon="'chair'" />
      <span class="current-area__title">
        {{ $t("modal.choose_area.section") }}
      </span>
      <span class="current-area__value">{{ sectionName }}</span>
    </h3>
    <h3 class="current-area__item">
      <font-awesome-icon class="current-area__icon" :icon="['far', 'ticket-alt']" />
      <span class="current-area__title">
        {{ $t("ticket.price") }}
      </span>
      <span class="current-area__value">{{ sectionPrice }}</span>
    </h3>
    <h3 class="current-area__item">
      <font-awesome-icon class="current-area__icon" :icon="'check-circle'" />
      <span class="current-area__title">
        {{ $t("modal.choose_area.availability") }}
      </span>
      <span class="current-area__value">
        {{ sectionAvailability }}
      </span>
    </h3>
  </div>
</template>

<script>
export default {
  name: "current-area-info",
  props: {
    sectionName: {
      type: String,
      required: false,
    },
    sectionPrice: {
      type: String,
      required: false,
    },
    sectionAvailability: {
      type: String,
      required: false,
    },
  },
};
</script>
